if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        // 初期表示時のボタン状態を反映
        this._initInquiryButton();

        // variantIdInputの変化を監視してバリアント名を取得
        const observer = new MutationObserver(() => {
          this._updateCurrentVariantTitle();
        });
        observer.observe(this.variantIdInput, { attributes: true, attributeFilter: ['value'] });
        // フォーム内のhidden inputのvalue変化はMutationObserverでは取れないので
        // subscribe経由でも補完する
        if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, (event) => {
            this._updateCurrentVariantTitle();
          });
        }
      }

      _updateCurrentVariantTitle() {
        const variantId = this.variantIdInput.value;
        if (!variantId || !window.shopifyProductVariants) return;
        const variant = window.shopifyProductVariants.find(v => String(v.id) === String(variantId));
        if (variant) {
          this.currentVariantTitle = variant.title;
        }
      }

      _initInquiryButton() {
        // ページ読み込み時点での在庫状態を確認してボタン表示を初期化
        const isDisabled = this.submitButton.hasAttribute('disabled');
        const buttonText = this.submitButtonText ? this.submitButtonText.textContent.trim() : '';
        const unreleasedText = this.submitButton.dataset.unreleasedText;
        const isSoldOut = isDisabled && !unreleasedText && buttonText === window.variantStrings?.soldOut;
        // variantStringsがまだ読み込まれていない場合はDOMContentLoaded後に再実行
        if (!window.variantStrings) {
          document.addEventListener('DOMContentLoaded', () => this._initInquiryButton(), { once: true });
          return;
        }
        this._updateCurrentVariantTitle();
        this.toggleInquiryButton(isSoldOut);
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
            document.dispatchEvent(new Event('cart:update'));
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        const unreleasedText = this.submitButton.dataset.unreleasedText;
        if (unreleasedText) {
          this.submitButton.setAttribute('disabled', 'disabled');
          this.submitButtonText.textContent = unreleasedText;
          this.toggleInquiryButton(false);
          return;
        }
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
          const isSoldOut = text === window.variantStrings.soldOut;
          this.toggleInquiryButton(isSoldOut);
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
          this.toggleInquiryButton(false);
        }
      }

      toggleInquiryButton(show) {
        const inquiryBtn = document.getElementById(
          `InquiryButton-${this.dataset.sectionId}`
        );
        if (!inquiryBtn) return;

        if (show) {
          inquiryBtn.style.display = '';
          // クリック時点で最新のバリアント名を取得するためdata属性に商品名だけ持たせる
          // バリアント名はクリック時にDOMから直接取得する
          const productTitle = inquiryBtn.dataset.productTitle || '';
          inquiryBtn.dataset.currentSubject = productTitle;
        } else {
          inquiryBtn.style.display = 'none';
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}